import styled from 'styled-components';

const CommentItemHeader = styled.div`
   display: flex;
  flex-direction: row;
`;

export default CommentItemHeader;
